import { EACG, INSTITUTIONAL_SITE_LOGIN, NORTH_AMERICA } from "@repo/utils";

export const getLoginProcessStepLabel = (audience: string): string => {
  return audience === NORTH_AMERICA
    ? INSTITUTIONAL_SITE_LOGIN
    : `${INSTITUTIONAL_SITE_LOGIN} - ${EACG}`;
};
